import { Component, inject, Input } from '@angular/core';
import { Params } from '@angular/router';
import { RoutingService } from '../../service/common/routing/routing.service';
import { PlanwertFilter } from '../../service/planwert/planwert-filter';

@Component({
    selector: 'redispatch-dashboard-planwerte',
    templateUrl: './dashboard-planwerte.component.html',
    standalone: false,
})
export class DashboardPlanwerteComponent {

    @Input()
    public invalidPlanwerteAvailable: boolean = false;

    @Input()
    public stadtwerkeId: string;

    @Input()
    public planwertFilter: PlanwertFilter;

    private routingService = inject(RoutingService);

    public get hasInvalidPlanwerte() : boolean {
        return this.invalidPlanwerteAvailable;
    }

    public get routerLink(): string | null {
        return this.routingService.planwertPath();
    }

    public get queryParams(): Params | null {
        if (this.hasInvalidPlanwerte) {
            this.planwertFilter.status = [
                '["INVALID"]',
            ];
            return this.planwertFilter;
        } else {
            return null;
        }
    }

}
